import { Size } from "geometry/geometry";
import * as React from "react";

/**
 * Observes container to get its size. Returns null when container is unavailable.
 * Used to ensure canvas min size equals parent (viewport) for full background display.
 */
export const useViewportSize = (
    container: HTMLDivElement | null
): Size | null => {
    const [size, setSize] = React.useState<Size | null>(null);

    React.useEffect(() => {
        if (container === null) {
            setSize(null);
            return;
        }

        const updateSize = () => {
            setSize({
                width: container.clientWidth,
                height: container.clientHeight,
            });
        };

        updateSize();

        const observer = new ResizeObserver(updateSize);
        observer.observe(container);

        return () => observer.disconnect();
    }, [container]);

    return container !== null ? size : null;
};
